import { Container } from "@material-ui/core";
import { Route, Switch } from "react-router-dom";
import HomeScreen from "../modules/home/screens/HomeScreen";

const Home = () => {
  return (
    <Container maxWidth={false}>
      <Switch>
        <Route exact path="/home" component={HomeScreen} />
        {/* <Route path="/home/add" component={AddNewBLExportScreen} /> */}
        {/* <Route path="/home/clone" component={CloneBlExportScreen} /> */}
      </Switch>
    </Container>
  );
};

export default Home;
